import { render, staticRenderFns } from "./AddressesDetailPopUp.vue?vue&type=template&id=2fb630b9&scoped=true&"
import script from "./AddressesDetailPopUp.vue?vue&type=script&lang=js&"
export * from "./AddressesDetailPopUp.vue?vue&type=script&lang=js&"
import style0 from "./AddressesDetailPopUp.vue?vue&type=style&index=0&id=2fb630b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb630b9",
  null
  
)

export default component.exports